import { AbstractControl, FormControl, FormControlOptions, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

const passwordMinLength = 10;

/**
 * The key of the validation error for a field where the password doesn't match
 */
export const passwordRequirementsValidationErrorKey = 'passwordValidation';

/**
 * Validator for validating password minimum requirements
 * @param control Form control
 */
const validatePasswordRequirements: ValidatorFn = (control: AbstractControl<string>): ValidationErrors => {
  const value = control.value;

  if (!value) {
    return null;
  }

  const hasUpperCase = value.match(/[A-Z]/g) !== null;
  const hasLowerCase = value.match(/[a-z]/g) !== null;
  const hasNumeric = value.match(/[0-9]/g) !== null;
  const hasSpecial = value.match(/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/g) !== null;

  const isValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecial;

  if (!isValid) {
    return {
      [passwordRequirementsValidationErrorKey]: true
    };
  }

  return null;
};

/**
 * Creates a FormControl which is configured as a password field. Can be used in user pages and everywhere else where a
 * password should be provided by the user. (Except login form)
 * @param defaultValue Default value
 * @param opts Form control options
 */
export const createPasswordFormControl = (defaultValue: string, opts: FormControlOptions = {}): FormControl<string> => {
  const validators: ValidatorFn[] = [Validators.required, Validators.minLength(passwordMinLength), validatePasswordRequirements];

  return new FormControl<string>(defaultValue, { updateOn: 'change', ...opts, validators });
};
